import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    bothRole: 'Director and shareholder of at least 25% of the shares',
    directorRole: 'Director',
    majorShareholderRole: 'Shareholder of at least 25% of the shares',
    toComplete: 'Information to be completed',
  },
  fr: {
    bothRole: 'Dirigeant·e et actionnaire d’au moins 25 % des parts',
    directorRole: 'Dirigeant·e',
    majorShareholderRole: 'Actionnaire d’au moins 25 % des parts',
    toComplete: 'Informations à compléter',
  },
} as const);
